import { Link } from "react-router-dom";

const LOGO_LIGHT = "https://customer-assets-lxgj4vgw.emergentagent.net/job_serpnex-stage/artifacts/hcoc6gmr_serpnex%20light%20bg%20logo.jpeg";
const LOGO_DARK = "https://customer-assets-lxgj4vgw.emergentagent.net/job_serpnex-stage/artifacts/5fnxr8nk_serpnex%20dark%20bg%20logo.jpeg";

// Both assets are JPEGs with checkerboard "transparency" pattern baked into pixels.
// We crop into the actual logo mark (middle horizontal band) via cover + centered position,
// push light pixels to pure white with contrast/brightness, then use blend modes to hide the
// background — multiply on light surfaces, invert + screen on dark surfaces.
export default function Logo({ className = "", variant = "light", size = "md" }) {
  const dims = size === "lg"
    ? { h: 56, w: 260 }
    : size === "sm"
      ? { h: 28, w: 130 }
      : { h: 36, w: 168 };

  const src = variant === "dark" ? LOGO_DARK : LOGO_LIGHT;
  // Light variant: navy logo on white checkerboard. Push checkerboard to white and multiply-blend it away.
  // Dark variant: metallic silver logo on dark checkerboard. Push checkerboard to black and screen-blend it away.
  const filter = variant === "dark"
    ? "brightness(0.6) contrast(2.2) saturate(1.15)"
    : "brightness(1.35) contrast(1.55) saturate(1.1)";

  return (
    <Link to="/" data-testid="brand-logo" className={`inline-flex items-center ${className}`} aria-label="SerpNex">
      <div
        role="img"
        aria-label="SerpNex"
        className="select-none shrink-0"
        style={{
          height: dims.h,
          width: dims.w,
          backgroundImage: `url("${src}")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          mixBlendMode: variant === "dark" ? "screen" : "multiply",
          filter,
        }}
      />
    </Link>
  );
}
